(function () {
  'use strict';

  /* ===================================================
     hi-marquee.js
     - CSS変数をdata属性から注入（speed / gap / card-width / bg / text-color）
     - ライトボックスの開閉
  =================================================== */

  function initMarquee() {
    var section = document.querySelector('.hi-marquee');
    if (!section) return;

    /* --- CSS変数をdata属性から注入 --- */
    var speed     = section.dataset.speed     || '30';
    var gap       = section.dataset.gap       || '20';
    var cardWidth = section.dataset.cardWidth || '260';
    var bgColor   = section.dataset.bgColor   || '#f7f5f2';
    var textColor = section.dataset.textColor || '#1a1a1a';

    section.style.backgroundColor            = bgColor;
    section.style.setProperty('--hi-speed',      speed + 's');
    section.style.setProperty('--hi-gap',         gap + 'px');
    section.style.setProperty('--hi-card-width',  cardWidth + 'px');
    section.style.setProperty('--hi-text-color',  textColor);

    /* --- ライトボックス --- */
    var lb      = document.getElementById('js-hi-lb');
    var lbImg   = document.getElementById('js-hi-lb-img');
    var lbCap   = document.getElementById('js-hi-lb-caption');
    var lbClose = document.getElementById('js-hi-lb-close');
    var lbBg    = document.getElementById('js-hi-lb-bg');

    if (!lb) return;

    function openLb(src, name) {
      if (!src) return;
      lbImg.src = src;
      lbImg.alt = name || '';
      lbCap.textContent = name || '';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }

    function closeLb() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    /* カード全件にクリック登録（1セット目・2セット目ともに同じ画像を開く） */
    document.querySelectorAll('.hi-marquee__card[data-lb-src]').forEach(function (el) {
      el.addEventListener('click', function () {
        openLb(el.dataset.lbSrc, el.dataset.lbName);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLb(el.dataset.lbSrc, el.dataset.lbName);
        }
      });
    });

    lbClose.addEventListener('click', closeLb);
    lbBg.addEventListener('click', closeLb);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb();
    });
  }

  /* DOMContentLoaded 後に実行 */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }

})();